(function () {
  const CHECKBOX_SELECTOR = '.js-cart-terms-checkbox';
  const ERROR_SELECTOR = '.js-cart-terms-error';

  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href*="/checkout"]',
    '.cart__checkout',
    '.btn-checkout',
    '#CartDrawer-Checkout'
  ].join(',');

  let syncTimeout = null;

  function getCheckboxes() {
    return Array.from(document.querySelectorAll(CHECKBOX_SELECTOR));
  }

  function getCheckoutButtons() {
    return Array.from(document.querySelectorAll(CHECKOUT_SELECTOR));
  }

  function isAccepted() {
    return getCheckboxes().some(function (checkbox) {
      return checkbox.checked === true;
    });
  }

  function syncCheckboxes(sourceCheckbox) {
    if (!sourceCheckbox) return;

    getCheckboxes().forEach(function (checkbox) {
      checkbox.checked = sourceCheckbox.checked;
    });
  }

  function showErrors() {
    document.querySelectorAll(ERROR_SELECTOR).forEach(function (error) {
      error.style.display = 'block';
    });
  }

  function hideErrors() {
    document.querySelectorAll(ERROR_SELECTOR).forEach(function (error) {
      error.style.display = 'none';
    });
  }

  function syncTermsState() {
    const accepted = isAccepted();

    getCheckoutButtons().forEach(function (button) {
      if (button.tagName === 'A') {
        button.setAttribute('aria-disabled', accepted ? 'false' : 'true');
        button.classList.toggle('disabled', !accepted);
        button.style.pointerEvents = accepted ? '' : 'none';
        button.style.opacity = accepted ? '' : '0.6';
      } else {
        button.disabled = !accepted;
        button.setAttribute('aria-disabled', accepted ? 'false' : 'true');
      }
    });

    if (accepted) {
      hideErrors();
    }
  }

  function bindCheckboxes() {
    getCheckboxes().forEach(function (checkbox) {
      if (checkbox.dataset.termsBound === 'true') return;

      checkbox.dataset.termsBound = 'true';

      checkbox.addEventListener('change', function () {
        syncCheckboxes(checkbox);
        syncTermsState();
      });
    });
  }

  function initTermsValidation() {
    bindCheckboxes();
    syncTermsState();
  }

  function scheduleSync() {
    clearTimeout(syncTimeout);

    syncTimeout = setTimeout(function () {
      initTermsValidation();
    }, 50);
  }

  document.addEventListener(
    'click',
    function (event) {
      const checkoutButton = event.target.closest(CHECKOUT_SELECTOR);

      if (!checkoutButton) return;

      if (!isAccepted()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        showErrors();
        syncTermsState();

        const firstCheckbox = document.querySelector(CHECKBOX_SELECTOR);

        if (firstCheckbox) {
          firstCheckbox.focus();
        }

        return false;
      }
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!event.target.matches(CHECKBOX_SELECTOR)) return;

    syncCheckboxes(event.target);
    syncTermsState();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initTermsValidation();

    setTimeout(initTermsValidation, 100);
    setTimeout(initTermsValidation, 500);
    setTimeout(initTermsValidation, 1000);
  });

  window.addEventListener('load', function () {
    initTermsValidation();
  });

  window.addEventListener('pageshow', function () {
    initTermsValidation();

    setTimeout(initTermsValidation, 100);
    setTimeout(initTermsValidation, 500);
  });

  const observer = new MutationObserver(function () {
    scheduleSync();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();